/* jshint esversion: 6 */
import { useEffect, useState } from 'react';
import * as _ from 'underscore';
import { SUB_PREVIEW_ADDONS } from 'app/redux/constants.js';

const NOTHING_DUE = { status: 'ready', dueToday: 0, credit: 0, nextBillDate: null };

/*
 * Asks for a preview of `post` once, on mount, and reports how it's going in the shape
 * the PlanChange dialogs take: loading, ready with the amounts, or error. Only a preview
 * of this exact request counts as ready. `type` is SUB_PREVIEW_ADDONS or
 * SUB_PREVIEW_UPDATE; with `enabled` false nothing is requested and nothing is due.
 */
export default function useChangePreview(props, type, post, enabled = true) {
    const [requested, setRequested] = useState(false);

    useEffect(() => {
        if (!enabled) {
            return;
        }
        if (type === SUB_PREVIEW_ADDONS) {
            props.previewAddOns(post);
        } else {
            props.previewUpdate(post);
        }
        setRequested(true);
    }, []);

    if (!enabled) {
        return NOTHING_DUE;
    }

    const preview = props.plans.changePreview;
    if (preview?.type === type && _.isEqual(preview.post, post)) {
        return { status: 'ready', ...preview.payload };
    }
    if (requested && !props.app.loading[type] && props.getApiErrors([type]).length) {
        return { status: 'error' };
    }

    return { status: 'loading' };
}

/** Reports the checkout funnel's confirmation step to the dataLayer when a confirm dialog opens. */
export function useConfirmationStep(enabled = true, option = 'Confirmation') {
    useEffect(() => {
        if (enabled && window.dataLayer) {
            window.dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 2, 'option': option}
                    }
                }
            });
        }
    }, []);
}
